/* eslint-disable */
import { Button, Chip, Grid, IconButton, Menu, Snackbar, Typography } from '@material-ui/core';
import Checkbox from '@material-ui/core/Checkbox';
import MenuItem from '@material-ui/core/MenuItem';
import { withStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import withWidth, { isWidthDown } from '@material-ui/core/withWidth';
import AddCommentIcon from '@material-ui/icons/AddComment';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import ArrowForwardIcon from '@material-ui/icons/ArrowForward';
import BusinessIcon from '@material-ui/icons/Business';
import CloseIcon from '@material-ui/icons/Close';
import DateRangeIcon from '@material-ui/icons/DateRange';
import ErrorIcon from '@material-ui/icons/Error';
import LibraryBooksIcon from '@material-ui/icons/LibraryBooks';
import ModeCommentIcon from '@material-ui/icons/ModeComment';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import NoteAddIcon from '@material-ui/icons/NoteAdd';
import PictureAsPdfIcon from '@material-ui/icons/PictureAsPdf';
import PlaylistAddCheckIcon from '@material-ui/icons/PlaylistAddCheck';
import SaveAltIcon from '@material-ui/icons/SaveAlt';
import ViewColumnIcon from '@material-ui/icons/ViewColumn';
import VisibilityIcon from '@material-ui/icons/Visibility';
import DateRangePicker from '@wojtekmaj/react-daterange-picker';
import cn from 'classnames';
import { saveAs } from 'file-saver';
import JSZip from 'jszip';
import moment from 'moment';
import React, { useEffect, useLayoutEffect, useRef, useState } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { bindActionCreators, compose } from 'redux';
import { empty, fromEvent } from 'rxjs';
import { catchError, debounceTime, delay, filter, retry, scan, switchMap, tap } from 'rxjs/operators';
import { ORDER_API_DATE_FORMAT } from '../../Constants/Order/Order.constants';
import reportsUrls from '../../Constants/Report/Report.constants';
import withServices from '../../Contexts/Services/WithServices.context';
import { createOrderPageLink } from '../../Pages/Order/Order.page.route';
import docketsActionCreators from '../../State/Store/Dockets/Dockets.actions';
import filtersActionCreators from '../../State/Store/Filters/Filters.actions';
import getFiltersSelectedAccount from '../../State/Store/Filters/Selectors/FiltersSelectedAccount.selector';
import uiActionCreators from '../../State/Store/UI/UI.actions';
import {
  UI_DOCKET_ACCOUNT_CHANGE_DOCKETS_PAGE,
  UI_DOCKET_COLUMNS_CHANGE_DOCKETS_PAGE,
  UI_DOCKET_DATE_RANGE_CHANGE_DOCKETS_PAGE,
  UI_DOCKET_DETAILS_DOCKETS_PAGE,
  UI_DOCKET_DOWNLOAD_DOCKETS_PAGE,
  UI_DOCKET_LIST_REPORT_ISSUE,
  UI_DOCKET_ORDER_VIEWED_DOCKETS_PAGE,
  UI_DOWNLOAD_CSV_DOCKETS_PAGE,
  UI_DOWNLOAD_DATE_RANGE_DOCKETS_PAGE,
  UI_DOWNLOAD_DATE_RANGE_PDF_DOCKETS_PAGE,
  UI_DOWNLOAD_PDF_DOCKETS_PAGE,
} from '../../State/Store/UI/UI.types';
import userProfileSelector from '../../State/Store/UserProfile/Selectors/UserProfileCurrent.selector';
import dateOnly from '../../Support/DateTime/DateOnly/DateTimeDateOnly.support';
import envGet from '../../Support/Env/Get/EnvGet.support';
import DeliveryDocketPdf from '../../Support/Generators/DeliveryDocketPdf/DeliveryDocketPdf';
import helpers from '../../Support/Text';
import themeCreateInjectableStyles from '../../Support/Theme/CreateInjectableStyles/ThemeCreateInjectableStyles.support';
import AccountSwitcher from '../AccountSwitcher/AccountSwitcher.component';
import DeliveryDocketAddNote from '../DeliveryDocket/DeliveryDocketAddNote.component';
import DeliveryDocketModal from '../DeliveryDocket/DeliveryDocketModal.component';
import DeliveryDocketReportIssue from '../DeliveryDocket/DeliveryDocketReportIssue.component';
import Modal from '../Modal/Modal.component';
import Spinner from '../Spinner/Spinner.component';
import ColumnsSelector from './ColumnsSelector.component';
import DocketsListPropTypes from './DocketsList.component.props';
import docketsListStyles from './DocketsList.component.styles';
import SearchDockets from './SearchDockets.component';
import DocketsTable from './parts/DocketsTable/DocketsTable.component'
import DownloadBar from './parts/DownloadBar/DownloadBar.component'
// import SearchBar from './parts/SearchBar/SearchBar.component'
import FilterListIcon from '@material-ui/icons/FilterList';
import Hidden from '@material-ui/core/Hidden';

const REACT_APP_BORAL_FEATURE_TOGGLE_DOCKETS_GLOBAL_PDF_DOWNLOAD = envGet({ key: `REACT_APP_BORAL_FEATURE_TOGGLE_DOCKETS_GLOBAL_PDF_DOWNLOAD` }) === `true`;

/**
 * DocketsList
 * @param {any} props The props
 * @returns {React.Component} The component
 */
const DocketsList = ({ actions, classes, history, listSettings, services, userInfo, width, currentAccountGlobal }) => {
  const initialRange = [
    moment(new Date())
      .startOf(`month`)
      .subtract(2, `month`)
      .toDate(),
    new Date(),
  ];
  const initialColumns = [
    { label: `Date`, name: `ticketDate`, selected: true, sortable: true },
    { label: `Time Batched`, name: `timeBatched`, selected: false, sortable: false },
    { label: `Time Left Plant`, name: `timeLeftPlant`, selected: false, sortable: false },
    { label: `Time Arrived`, name: `arrivedTime`, selected: true, sortable: false },
    { label: `Time Start Unloading`, name: `timeStartUnloading`, selected: false, sortable: false },
    { label: `Time Finished Unloading`, name: `timeFinishedUnloading`, selected: false, sortable: false },
    { label: `Time Left Site`, name: `timeLeftSite`, selected: false, sortable: false },
    { label: `Time On Site`, name: `timeOnSite`, selected: false, sortable: true },
    { label: `To (Street)`, name: `street`, selected: true, sortable: true },
    { label: `Lot #`, name: `lotNumber`, selected: false, sortable: true },
    { label: `Product`, name: `product`, selected: true, sortable: true },
    { label: `Product Code`, name: `productCode`, selected: true, sortable: true },
    { label: `Order #`, name: `orderCode`, selected: true, sortable: true },
    { label: `P/Order #`, name: `purchaseCode`, selected: true, sortable: true },
    { label: `Docket #`, name: `docketNumber`, selected: true, sortable: true },
    { label: `Job Reference`, name: `jobReference`, selected: false, sortable: true },
    { label: `Accepted`, name: `accepted`, selected: false, sortable: true },
    { label: `Suburb`, name: `suburb`, selected: false, sortable: true },
    { label: `Plant`, name: `plant`, selected: false, sortable: true },
    { label: `Est. Distance`, name: `estDistance`, selected: false, sortable: false },
    { label: `Truck Type`, name: `truckType`, selected: false, sortable: true },
    { label: `Truck Number`, name: `truckNumber`, selected: false, sortable: true },
    { label: `Project Name`, name: `projectName`, selected: false, sortable: true },
    { label: `Last Updated`, name: `lastUpdateDate`, selected: false, sortable: true },
    { label: `Product Type`, name: `productType`, selected: false, sortable: true },
    { label: `Requested Slump`, name: `slump`, selected: false, sortable: true },
    { label: `Mix Code`, name: `mixCode`, selected: false, sortable: true },
    { label: `Quantity`, name: `quantity`, selected: false, sortable: true },
    { label: `Water Designed`, name: `waterDesigned`, selected: false, sortable: true },
    { label: `Water Batched`, name: `waterBatched`, selected: false, sortable: true },
    { label: `Water Added at plant`, name: `waterAtPlant`, selected: false, sortable: true },
    { label: `Water Added on site`, name: `waterOnSite`, selected: false, sortable: true },
    { label: `Service Fees`, name: `serviceFeesCount`, selected: true, sortable: true },
    { label: `Notes`, name: `notes`, selected: false, sortable: false },
    { label: `Docket Status`, name: `docketStatus`, selected: true, sortable: true },
  ];

  const scrollableContainerChildRef = useRef();
  const rangePickerRef = useRef();
  const smallScreen = isWidthDown(`xs`, width);
  const [dockets, setDockets] = useState([]);
  const [columnsOpen, setColumnsOpen] = useState(false);
  // const [showLegal, setShowLegal] = useState(false);
  const [docketDetailsOpen, setDocketDetailsOpen] = useState(false);
  const [docketPhoneNumber, setDocketPhoneNumber] = useState(null);
  const [currentDocket, setCurrentDocket] = useState(false);
  const [kebabAnchor, setKebabAnchor] = useState(false);
  const [showReportAnIssue, setShowReportAnIssue] = useState(false);
  const [downloadRangeAnchor, setDownloadRangeAnchor] = useState(null);
  const [dateFromTo, setDateFromTo] = useState(initialRange);
  const [zippingPdfsOpen, setZippingPdfsOpen] = useState(false);
  const [rangePickerOpen, setRangePickerOpen] = useState(false);
  const [accountSwitcherOpen, setAccountSwitcherOpen] = useState(false);
  const [accounts, setAccounts] = useState([]);
  const [checked, setChecked] = useState([]);
  // now as currentAccountGlobal is introduced to read original value from redux, consider if its possible to retire currentAccount and use currentAccountGlobal everywhere in its place. This is also if it can be removed from saving in listSettings.
  const [currentAccount, setCurrentAccount] = useState(currentAccountGlobal);
  const [exportRowsMenu, setExportRowsMenu] = useState(null);
  const [sortBy, setSortBy] = useState({ asc: false, name: `ticketDate` });
  const [columns, setColumns] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [allChecked, setAllChecked] = useState(false);
  const [error, setError] = useState(false);
  const [keyword, setKeyword] = useState(null);
  const [showAddNote, setShowAddNote] = useState(false);

  useLayoutEffect(() => {
    // get access to rangePicker so we can modify it outside of what is provided with this component
    const rangePicker = rangePickerRef.current.children[0];
    rangePicker.children[0].style = `display: none`;

    let firstCall = null;
    setIsLoading(true);
    // below is a candidate for custom hook maybe?
    (async () => {
      setSortBy(listSettings ? { asc: listSettings.order === `asc`, name: listSettings.sort } : { asc: false, name: `ticketDate` });
      setDateFromTo(listSettings ? [new Date(listSettings.dateFrom), new Date(listSettings.dateTo)] : initialRange);
      setColumns(listSettings && listSettings.columns ? listSettings.columns : initialColumns);

      const retrievedAccounts = await services.userService.getUserAccounts();
      const billToAccounts = services.authService.getGroups() || [];
      // find names associated with each billToAccount
      setAccounts(
        billToAccounts.map((billToAccount) => {
          const foundAccount = retrievedAccounts.accounts.find((account) => {
            return helpers.getNumberFromBillTo(billToAccount) === account.CustomerCode.trim();
          });
          if (foundAccount) {
            return {
              accountName: foundAccount.AccountName,
              billTo: helpers.getNumberFromBillTo(billToAccount),
            };
          }
          // no matching account name then as a backup display billTo number
          return {
            accountName: billToAccount,
            billTo: helpers.getNumberFromBillTo(billToAccount),
          };
        }),
      );

      let settings = {
        account: helpers.getNumberFromBillTo(currentAccountGlobal),
        dateFrom: dateFromTo[0],
        dateTo: dateFromTo[1],
        order: sortBy.asc ? `asc` : `desc`,
        sort: sortBy.name,
        total: 50,
      };
      if (listSettings) {
        settings = {
          ...listSettings,
          account: helpers.getNumberFromBillTo(currentAccountGlobal),
          keyword,
        };
      }

      firstCall =
        services.orderService &&
        services.orderService
          .getDockets(settings)
          .pipe(
            retry(1),
            catchError((err) => {
              setError(true);
              setIsLoading(false);
              return empty();
            }),
          )
          .subscribe((result) => {
            setIsLoading(false);
            if (Array.isArray(result.dockets)) {
              setDockets(result.dockets);
            }
          });
      setCurrentAccount(helpers.getNumberFromBillTo(currentAccountGlobal));
    })();

    return () => {
      if (firstCall) {
        firstCall.unsubscribe();
      }
    };
  }, []);

  let mainCall = null;
  useEffect(() => {
    if (mainCall) {
      mainCall.unsubscribe();
    }
    const scrollable = scrollableContainerChildRef.current.parentElement;
    // pixelperfecting height using clientHeight rather then vh units so the horizontal scrollbar can still be in visible viewport
    scrollable.style = `padding: 0px;overflow: auto;`;
    scrollableContainerChildRef.current.style = `height: ${scrollable.clientHeight}px;`;
    // make initial call

    const fromScroll$ = fromEvent(scrollable, `scroll`);
    const scrollingDown$ = fromScroll$.pipe(
      debounceTime(200),
      scan(
        (acc, el) => {
          return [acc[1], el.target.scrollTop];
        },
        [0, 0],
      ),
      filter((el) => el[1] > el[0]),
    );

    const scrollable$ = scrollingDown$.pipe(
      filter((el) => {
        return scrollable.scrollTop + scrollable.clientHeight >= scrollable.scrollHeight - scrollable.scrollHeight * 0.2;
      }),
      scan((acc) => {
        return acc + 50;
      }, 0),
      tap(() => {
        setIsLoading(true);
      }),
      delay(1000),
      switchMap((total) => {
        return services.orderService
          .getDockets({
            account: helpers.getNumberFromBillTo(currentAccount),
            dateFrom: dateFromTo[0],
            dateTo: dateFromTo[1],
            keyword,
            order: sortBy.asc ? `asc` : `desc`,
            sort: sortBy.name,
            total,
          })
          .pipe(
            retry(1),
            catchError((err) => {
              setError(true);
              return empty();
            }),
          );
      }),
      tap((el) => setIsLoading(false)),
    );

    mainCall = scrollable$.subscribe((result) => {
      if (Array.isArray(result.dockets)) {
        setDockets(result.dockets);
      }
    });

    return () => {
      mainCall.unsubscribe();
    };
  }, [currentAccount, dateFromTo, keyword, sortBy]);

  /**
   * Opens Report an issue dialog
   * @param {object} docket docket
   * @returns {void} void
   * @memberof DocketsList
   */
  const reportAnIssue = (docket) => {
    actions.uiTriggered({
      payload: {
        data: {
          name: `docketListReportIssue`,
          phoneNumber: docket.callBoral,
        },
      },
      type: UI_DOCKET_LIST_REPORT_ISSUE,
    });
    // setDocketPhoneNumber(docket.phoneNumber);
    setDocketPhoneNumber(docket.callBoral);
    setKebabAnchor(null);
    setShowReportAnIssue(true);
    return;
  };

  /**
   * Updates selected columns
   * @param {Array} updatedColumns updated columns
   * @returns {void} void
   * @memberof DocketsList
   */
  const applyColumns = (updatedColumns) => {
    actions.uiTriggered({
      payload: {
        data: {
          name: `docketColumnsChangeDocketsPage`,
        },
      },
      type: UI_DOCKET_COLUMNS_CHANGE_DOCKETS_PAGE,
    });
    const docketsListSettings = {
      account: helpers.getNumberFromBillTo(currentAccount),
      columns: updatedColumns,
      dateFrom: dateFromTo[0],
      dateTo: dateFromTo[1],
      keyword,
      order: sortBy.asc ? `asc` : `desc`,
      sort: sortBy.name,
      total: 50,
    };

    actions.docketsListSettings(docketsListSettings);
    setColumns(updatedColumns);
    setColumnsOpen(false);
    return;
  };

  /**
   * Requests sort
   * @param {Object} column updated columns
   * @returns {void} void
   * @memberof DocketsList
   */
  const requestSortBy = (column) => {
    // make a call to api here
    if (!isLoading) {
      const docketsListSettings = {
        account: helpers.getNumberFromBillTo(currentAccount),
        dateFrom: dateFromTo[0],
        dateTo: dateFromTo[1],
        keyword,
        order: sortBy.asc ? `desc` : `asc`,
        sort: column.name,
        total: 50,
      };

      actions.docketsListSettings(docketsListSettings);
      setIsLoading(true);
      services.orderService
        .getDockets(docketsListSettings)
        .pipe(
          retry(1),
          catchError((err) => {
            setError(true);
            setIsLoading(false);
            return empty();
          }),
        )
        .subscribe((result) => {
          if (Array.isArray(result.dockets)) {
            setChecked([]);
            if (column.name === sortBy.name) {
              setSortBy({ asc: !sortBy.asc, name: column.name });
            } else {
              setSortBy({ asc: false, name: column.name });
            }
            setIsLoading(false);
            setDockets(result.dockets);
          }
        });
    }
    return;
  };

  /**
   * Requests account change
   * @param {Object} account account requested
   * @returns {void} void
   * @memberof DocketsList
   */
  const requestAccount = async (account) => {
    actions.uiTriggered({
      payload: {
        data: {
          name: `docketAccountChangeDocketsPage`,
        },
      },
      type: UI_DOCKET_ACCOUNT_CHANGE_DOCKETS_PAGE,
    });

    const userAccounts = await services.authService.getGroups();

    actions.filtersSelectAccount(userAccounts.find((el) => el.startsWith(account)));
    // make a call to api here
    if (!isLoading) {
      const docketsListSettings = {
        account: helpers.getNumberFromBillTo(account),
        dateFrom: dateFromTo[0],
        dateTo: dateFromTo[1],
        keyword,
        order: sortBy.asc ? `asc` : `desc`,
        sort: sortBy.name,
        total: 50,
      };
      actions.docketsListSettings(docketsListSettings);
      setIsLoading(true);
      services.orderService
        .getDockets(docketsListSettings)
        .pipe(
          retry(1),
          catchError((err) => {
            setError(true);
            setIsLoading(false);
            return empty();
          }),
        )
        .subscribe((result) => {
          if (Array.isArray(result.dockets)) {
            setChecked([]);
            setCurrentAccount(account);
            setIsLoading(false);
            setDockets(result.dockets);
          }
        });
    }
    return;
  };

  /**
   * Requests account change
   * @param {Object} fromTo account requested
   * @returns {void} void
   * @memberof DocketsList
   */
  const requestDateChange = (fromTo) => {
    actions.uiTriggered({
      payload: {
        data: {
          name: `docketDateRangeChangeDocketsPage`,
        },
      },
      type: UI_DOCKET_DATE_RANGE_CHANGE_DOCKETS_PAGE,
    });
    // make a call to api here
    if (!isLoading) {
      const docketsListSettings = {
        account: helpers.getNumberFromBillTo(currentAccount),
        dateFrom: fromTo[0],
        dateTo: fromTo[1],
        keyword,
        order: sortBy.asc ? `asc` : `desc`,
        sort: sortBy.name,
        total: 50,
      };

      actions.docketsListSettings(docketsListSettings);
      setIsLoading(true);
      services.orderService
        .getDockets(docketsListSettings)
        .pipe(
          retry(1),
          catchError((err) => {
            setError(true);
            setIsLoading(false);
            return empty();
          }),
        )
        .subscribe((result) => {
          if (Array.isArray(result.dockets)) {
            setChecked([]);
            setDateFromTo(fromTo);
            setIsLoading(false);
            setDockets(result.dockets);
          }
        });
    }
    return;
  };

  /**
   * Closes docket details modal
   * @returns {void} void
   * @memberof DocketsList
   */
  const closeDetails = () => {
    setDocketDetailsOpen(false);
    // refresh table
    const docketsListSettings = {
      account: helpers.getNumberFromBillTo(currentAccount),
      dateFrom: dateFromTo[0],
      dateTo: dateFromTo[1],
      keyword,
      order: sortBy.asc ? `asc` : `desc`,
      sort: sortBy.name,
      total: dockets.length,
    };

    services.orderService
      .getDockets(docketsListSettings)
      .pipe(
        retry(1),
        catchError((err) => {
          setError(true);
          return empty();
        }),
      )
      .subscribe((result) => {
        if (Array.isArray(result.dockets)) {
          setDockets(result.dockets);
        }
      });
    return;
  };

  /**
   * Refreshes dockets list when docket accepted or unaccepted
   * @param {Object} updatedDocket docket
   * @returns {void} void
   * @memberof DocketsList
   */
  const onDocketAcceptChange = (updatedDocket) => {
    const updatedDockets = dockets.map((docket) => {
      if (docket.docketNumber === updatedDocket.docketNumber && docket.orderCode === updatedDocket.orderCode) {
        return {
          ...docket,
          accepted: !docket.accepted,
        };
      }
      return docket;
    });
    setDockets(updatedDockets);
  };

  /**
   * Opens docket details modal
   * @param {Object} docket docket
   * @returns {void} void
   * @memberof DocketsList
   */
  const openDetails = (docket) => {
    actions.uiTriggered({
      payload: {
        data: {
          name: `docketDetailsDocketsPage`,
        },
      },
      type: UI_DOCKET_DETAILS_DOCKETS_PAGE,
    });
    setDocketDetailsOpen(true);
    setCurrentDocket(docket);
    return;
  };

  /**
   * Returns if docket is already checked
   * @param {string} docketNumber The docket's number
   * @returns {boolean} boolean If docket is already checked
   * @memberof DocketsList
   */
  const isChecked = (docketNumber) => {
    return checked.includes(docketNumber);
  };

  /**
   * Downloads docket rows
   * @returns {void} void
   * @memberof DocketsList
   */
  const downloadPdfDockets = async () => {
    actions.uiTriggered({
      payload: {
        data: {
          name: `uiDownloadPdfDocketsPage`,
        },
      },
      type: UI_DOWNLOAD_PDF_DOCKETS_PAGE,
    });
    setExportRowsMenu(null);
    if (checked.length === 0) {
      return;
    }

    const settings = {
      account: currentAccount,
      dockets: dockets
        .filter((docket) => isChecked(docket.docketNumber))
        .map((docket, i) => {
          const date = dateOnly(docket.orderDate, ORDER_API_DATE_FORMAT);
          const orderCode = docket.orderCode.trim();
          return {
            date,
            orderCode,
            orderLine: docket.orderLine,
            docketNumber: docket.docketNumber,
          };
        }),
    };

    setZippingPdfsOpen(true);
    services.docketService
      .getDocketsPDFContent(settings)
      .pipe(retry(1))
      .subscribe({
        next: async (docketsFromAPI) => {
          const pdfDockets = await Promise.all(
            docketsFromAPI.map((docket, i) => {
              return DeliveryDocketPdf({ ...docketsFromAPI[i], docketId: docket.docketId }, { blob: true });
            }),
          );
          const zip = new JSZip();
          pdfDockets.map((docket, i) => zip.file(`Docket${docketsFromAPI[i].docketId}_${moment(docketsFromAPI[i].ticketDate).format(`DDMMYY`)}.pdf`, docket));
          setTimeout(async () => {
            setZippingPdfsOpen(false);
            const blob = await zip.generateAsync({ type: `blob` });
            saveAs(blob, `Dockets.zip`);
          }, 2000);
        },
        error: () => {
          setZippingPdfsOpen(false);
          setError(true);
        },
      });

    return;
  };

  /**
   * Hides columns selector
   * @returns {void} void
   * @memberof DocketsList
   */
  const cancelColumns = () => {
    setColumnsOpen(false);
    return;
  };

  /**
   * Handle menu download
   */
  const downloadHandler = async (docket) => {
    const requestPayload = {
      date: dateOnly(docket.orderDate, ORDER_API_DATE_FORMAT),
      orderCode: docket.orderCode.trim(),
      orderLine: docket.orderLine,
      ticketCode: docket.docketNumber,
    };
    debugger
    console.log("!!requestPayload",requestPayload)
    actions.uiTriggered({
      payload: {
        data: {
          name: `docketDownloadDocketsPage`,
        },
      },
      type: UI_DOCKET_DOWNLOAD_DOCKETS_PAGE,
    });
    setKebabAnchor(null);
    try {
      const result = await services.docketService.getDocketPDFContentSingle({
        ...requestPayload,
        account: currentAccount,
      })
      DeliveryDocketPdf({
        ...result.response,
        docketId: docket.docketNumber,
      })
    } catch (e) {
      //
    }
  };

  /**
   * Handle menu go to order
   */
  const goToOrderHandler = async (docket) => {
    actions.uiTriggered({
      payload: {
        data: {
          name: `docketOrderViewedDocketsPage`,
        },
      },
      type: UI_DOCKET_ORDER_VIEWED_DOCKETS_PAGE,
    });
    history.push(
      createOrderPageLink({ orderId: `${docket.orderDate.split(`T`)[0].replace(/(\d*)-(\d*)-(\d*)/, `$1$2$3`)}-${docket.orderCode}-${docket.orderLine}` }),
    );
    return;
  };

  /**
   * Handle menu icon click
   * @param {Event} event The `click` event
   * @param {Object} row unmodified docket with original ticketDate
   * @returns {void} void
   * @memberof DocketsList
   */
  const onMenuClick = (event, row) => {
    event.preventDefault();
    setKebabAnchor({ anchor: event.currentTarget, docket: row });
    return;
  };

  /**
   * Handle download range icon click
   * @param {Event} event The `click` event
   * @returns {void} void
   * @memberof DocketsList
   */
  const onDownloadRangeClick = (event) => {
    event.preventDefault();
    setDownloadRangeAnchor(event.currentTarget);
    return;
  };

  /**
   * Downloads docket date range
   * @returns {void} void
   * @memberof DocketsList
   */
  const getDocketsDateRangePdf = async () => {
    actions.uiTriggered({
      payload: {
        data: {
          name: `uiDownloadDateRangePdfDocketsPage`,
        },
      },
      type: UI_DOWNLOAD_DATE_RANGE_PDF_DOCKETS_PAGE,
    });
    setDownloadRangeAnchor(null);

    const settings = {
      account: currentAccount,
      dateFrom: moment(dateFromTo[0]).format(`YYYY-MM-DD`),
      dateTo: moment(dateFromTo[1]).format(`YYYY-MM-DD`),
      // generatedOn: moment().format(`DDMMYYYY`),
      // meta: reportsUrls[`docket-detail`],
    };

    setDownloadRangeAnchor(null);
    setZippingPdfsOpen(true);

    services.orderService
      .getDocketsDateRangePdf(settings)
      .pipe(retry(1))
      .subscribe({
        next: async (result) => {
          const pdfDockets = await Promise.all(
            result.map((docket, i) => {
              return DeliveryDocketPdf({ ...result[i], docketId: docket.docketId }, { blob: true });
            }),
          );
          const zip = new JSZip();
          pdfDockets.map((docket, i) => zip.file(`Docket${result[i].docketId}_${moment(result[i].ticketDate).format(`DDMMYY`)}.pdf`, docket));
          setTimeout(async () => {
            setZippingPdfsOpen(false);
            const blob = await zip.generateAsync({ type: `blob` });
            saveAs(blob, `${reportsUrls[`docket-detail`].fileNamePrefix}_${currentAccount}_${moment().format(`DDMMYYYY`)}.zip`);
          }, 2000);
        },
        error: () => {
          setZippingPdfsOpen(false);
          setError(true);
        },
      });

    return;
  };

  /**
   * Download CSV for date range selected
   * @returns {void} void
   * @memberof DocketsList
   */
  const getDocketsDateRangeCsv = async () => {
    actions.uiTriggered({
      payload: {
        data: {
          name: `uiDateRangeRequestedDocketsPage`,
        },
      },
      type: UI_DOWNLOAD_DATE_RANGE_DOCKETS_PAGE,
    });

    const settings = {
      account: currentAccount,
      dateFrom: moment(dateFromTo[0]).format(`YYYY-MM-DD`),
      dateTo: moment(dateFromTo[1]).format(`YYYY-MM-DD`),
      generatedOn: moment().format(`DDMMYYYY`),
      meta: reportsUrls[`docket-detail`],
    };

    setDownloadRangeAnchor(null);

    services.docketService
      .getDocketsDateRangeCsv(settings)
      .pipe(retry(1))
      .subscribe({
        error: () => {
          setError(true);
        },
      });
    return;
  };

  /**
   * Download CSV for options selected
   * @returns {void} void
   * @memberof DocketsList
   */
  const getDocketsCsv = async () => {
    actions.uiTriggered({
      payload: {
        data: {
          name: `uiDownloadCsvDocketsPage`,
        },
      },
      type: UI_DOWNLOAD_CSV_DOCKETS_PAGE,
    });
    setExportRowsMenu(null);
    const settings = {
      account: currentAccount,
      columns: columns.reduce((acc, column) => {
        if (column.selected) {
          acc.push(column.name);
        }
        return acc;
      }, []),
      dateFrom: dateFromTo[0],
      dateTo: dateFromTo[1],
      docketIds: checked,
      generatedOn: moment().format(`DDMMYYYY`),
      meta: reportsUrls[`docket-detail`],
      order: sortBy.asc ? `asc` : `desc`,
      sort: sortBy.name,
      total: dockets.length,
    };

    services.docketService
      .getDocketsCsv(settings)
      .pipe(retry(1))
      .subscribe({
        error: () => {
          setError(true);
        },
      });
    return;
  };

  /**
   * Renders account switcher
   * @returns {Object} component
   * @memberof DocketsList
   */
  const renderAccountSwitcher = () => {
    return (
      <Grid className={cn(classes.flexGrow1, classes.account)} item xs={12}>
        <Grid className={classes.flexWrapNowrap} container justify="flex-end" spacing={2}>
          <Grid className={classes.accountIcon} item>
            <BusinessIcon />
          </Grid>
          <Grid item>
            <AccountSwitcher accounts={accounts} maxWidth={250} onChange={(account) => requestAccount(account)} value={currentAccount} />
          </Grid>
        </Grid>
      </Grid>
    );
  };

  /**
   * Renders account switcher for smaller screens
   * @returns {Object} component
   * @memberof DocketsList
   */
  const renderAccountSwitcherMobile = () => {
    return (
      <Grid className={cn(classes.textAlignRight)} item>
        <Grid container justify="flex-end">
          <Grid className={cn(classes.textAlignRight)} item>
            <IconButton aria-label="Columns" color="inherit" edge="start" onClick={() => setAccountSwitcherOpen(true)}>
              <BusinessIcon />
            </IconButton>
          </Grid>
          <span className={cn(classes.displayNone)}>
            <AccountSwitcher
              accounts={accounts}
              maxWidth={250}
              onChange={(account) => requestAccount(account)}
              onClose={() => setAccountSwitcherOpen(false)}
              open={accountSwitcherOpen}
              value={currentAccount}
            />
          </span>
        </Grid>
      </Grid>
    );
  };

  /**
   * Renders account switcher for smaller screens
   * @param {Object} e The event
   * @param {string} docketNumber The docket's number
   * @returns {void} void
   * @memberof DocketsList
   */
  const updateChecked = (e, docketNumber) => {
    e.preventDefault();
    if (!checked.includes(docketNumber)) {
      const updatedChecked = checked.slice();
      updatedChecked.push(docketNumber);
      setChecked(updatedChecked);
    } else {
      const updatedChecked = checked.slice();
      setChecked(updatedChecked.filter((el) => el !== docketNumber));
    }
    return;
  };

  /**
   * Opens Add a Note dialog
   */
  const showAddNoteModal = (docket) => {
    setKebabAnchor(null);
    setShowAddNote(docket);
    return;
  };

  /**
   * Renders account switcher for smaller screens
   */
  const updateCheckAll = () => {
    if (allChecked) {
      setAllChecked(false);
      setChecked([]);
    } else {
      setAllChecked(true);
      setChecked(dockets.map((docket) => docket.docketNumber));
    }
    return;
  };

  let selected = null;
  if (smallScreen) {
    selected = <Typography variant="h6">{checked.length} Selected</Typography>;
  } else {
    selected = (
      <Typography variant="h6">
        {checked.length} Docket{checked.length > 1 ? `s` : ``} Selected
      </Typography>
    );
  }

  return (
    <div ref={scrollableContainerChildRef}>
      <DeliveryDocketReportIssue phoneNumber={docketPhoneNumber} open={showReportAnIssue} onClose={() => setShowReportAnIssue(false)} isReporting={false} />
      <Snackbar
        action={[
          <IconButton aria-label="Close" className={classes.close} color="inherit" key="close" onClick={() => setError(false)}>
            <CloseIcon />
          </IconButton>,
        ]}
        anchorOrigin={{
          horizontal: `left`,
          vertical: `bottom`,
        }}
        className={classes.snackbar}
        ContentProps={{ classes: { root: classes.error } }}
        message={
          <span className={classes.snackbarMessage} id="client-snackbar">
            <ErrorIcon className={classes.snackbarIcon} />
            An error has occurred. Please try again later.
          </span>
        }
        open={error}
      />

      <Modal
        content={
          <Grid container>
            <Grid item xs={12}>
              <Typography variant="body1">We&apos;re zipping your files.</Typography>
            </Grid>
            <Grid item xs={12} className={classes.textAlignCentre}>
              <Spinner loaderStyles={classes.zippingSpinner} />
            </Grid>
          </Grid>
        }
        paperClasses={classes.paperClasses}
        preventFullScreen
        maxWidth="sm"
        open={!!zippingPdfsOpen}
        title={
          <Grid container>
            <Grid item xs={12}>
              Please wait...
            </Grid>
          </Grid>
        }
      />

      <DeliveryDocketAddNote docket={showAddNote} open={showAddNote} onClose={() => setShowAddNote(false)} />
      <Menu anchorEl={kebabAnchor ? kebabAnchor.anchor : null} onClose={() => setKebabAnchor(null)} open={!!kebabAnchor}>
        <MenuItem
          onClick={() => {
            openDetails(kebabAnchor.docket);
            setKebabAnchor(null);
          }}
        >
          <VisibilityIcon className={classes.iconLeft} />
          View
        </MenuItem>
        <MenuItem onClick={() => downloadHandler(kebabAnchor.docket)}>
          <PictureAsPdfIcon className={classes.iconLeft} />
          Download PDF
        </MenuItem>
        <MenuItem onClick={() => showAddNoteModal(kebabAnchor.docket)}>
          <AddCommentIcon className={classes.iconLeft} />
          Add a Note
        </MenuItem>
        <MenuItem onClick={() => goToOrderHandler(kebabAnchor.docket)}>
          <ArrowForwardIcon className={classes.iconLeft} />
          Go To Order
        </MenuItem>
        <MenuItem onClick={() => reportAnIssue(kebabAnchor.docket)}>
          <ErrorIcon className={cn(classes.iconLeft)} />
          Report an issue
        </MenuItem>
      </Menu>
      <DeliveryDocketModal
        onDocketAcceptChange={() => onDocketAcceptChange(currentDocket)}
        currentDocket={currentDocket}
        currentAccount={currentAccount}
        onCloseDetails={closeDetails}
        open={!!docketDetailsOpen}
      />
      <DownloadBar
        checked={checked}
        selected={selected}
        smallScreen={smallScreen}
        setExportRowsMenu={setExportRowsMenu}
        exportRowsMenu={exportRowsMenu}
        getDocketsCsv={getDocketsCsv}
        downloadPdfDockets={downloadPdfDockets}
      />
      <Grid className={cn(classes.bar, checked.length && classes.hiddenBar)} container justify="flex-end">
        <Grid item xs={12}>
          <Grid alignItems="center" className={classes.flexWrapNowrap} container justify="flex-end" spacing={2}>
            <Grid item xs={12}>
              <Grid className={cn(classes.flexWrapNowrap,classes.alignItemsCenter)} container spacing={2}>
                  <Grid item>
                     <Hidden mdUp>
                        <IconButton aria-label="Columns" className={classes.columnsIcon} color="inherit" edge="start" onClick={() => setColumnsOpen(true)}>
                          <FilterListIcon />
                        </IconButton>
                      </Hidden>
                     <Hidden smDown>
                        <Button aria-label="Columns" className={classes.columnsIcon} color="inherit" edge="start" onClick={() => setColumnsOpen(true)}>
                          <FilterListIcon className={classes.iconLeft} />
                        <Typography variant="subtitle2" className={classes.menuHeading}>FILTER</Typography>
                        </Button>
                      </Hidden>
                    {columns && (
                      <ColumnsSelector
                        applyColumns={applyColumns}
                        cancelColumns={cancelColumns}
                        classes={classes}
                        onClose={() => setColumnsOpen(false)}
                        onOpen={() => setColumnsOpen(true)}
                        open={columnsOpen}
                        originalColumns={columns}
                      />
                    )}
                  </Grid>
                <Grid className={classes.flexGrow1} className={cn(classes.search)} item>
                  {currentAccount && (
                    <SearchDockets
                      account={helpers.getNumberFromBillTo(currentAccount)}
                      dateFrom={dateFromTo[0]}
                      dateTo={dateFromTo[1]}
                      onError={(el) => {
                        setError(true);
                        setIsLoading(false);
                      }}
                      onResults={(result) => {
                        if (Array.isArray(result.dockets)) {
                          setChecked([]);
                          setAllChecked(false);
                          setIsLoading(false);
                          setDockets(result.dockets);
                        }
                      }}
                      onStartSearch={(el) => {
                        setIsLoading(true);
                        setKeyword(el);
                      }}
                      order={sortBy.asc ? `asc` : `desc`}
                      sort={sortBy.name}
                      total={50}
                    />
                  )}
                </Grid>
              </Grid>
            </Grid>
            {smallScreen ? renderAccountSwitcherMobile() : renderAccountSwitcher()}
            <Grid className={cn(classes.textAlignRight)} item>
              <IconButton aria-label="Date/Range selector" color="inherit" edge="start" onClick={() => setRangePickerOpen(true)}>
                <DateRangeIcon />
              </IconButton>
              <div className={classes.dateRangePicker} ref={rangePickerRef}>
                <DateRangePicker
                  isOpen={rangePickerOpen}
                  maxDate={new Date()}
                  minDate={moment(new Date())
                    .startOf(`month`)
                    .subtract(2, `month`)
                    .toDate()}
                  onCalendarClose={() => setRangePickerOpen(false)}
                  onChange={(range) => {
                    setDateFromTo(range);
                    requestDateChange(range);
                  }}
                  value={dateFromTo}
                />
              </div>
            </Grid>
            <Grid className={cn(classes.textAlignRight)} item>
              {smallScreen ? (
                <IconButton aria-label="Download" color="inherit" edge="start" onClick={(e) => onDownloadRangeClick(e)}>
                  <SaveAltIcon />
                </IconButton>
              ) : (
                <Button aria-label="Download" color="inherit" edge="start" onClick={(e) => onDownloadRangeClick(e)}>
                  <SaveAltIcon className={classes.iconLeft} />
                  Export
                </Button>
              )}
              <Menu anchorEl={downloadRangeAnchor} onClose={() => setDownloadRangeAnchor(null)} open={!!downloadRangeAnchor}>
                <MenuItem disabled>
                  <Typography variant="subtitle2" className={classes.menuHeading}>
                    Export <b>all</b> from{' '}
                    <b>
                      {moment(dateFromTo[0]).format(`DD MMM`)} to {moment(dateFromTo[1]).format(`DD MMM`)}
                    </b>
                  </Typography>
                </MenuItem>
                <MenuItem onClick={getDocketsDateRangeCsv}>
                  <LibraryBooksIcon className={classes.iconLeft} />
                  Download CSV
                </MenuItem>
                {REACT_APP_BORAL_FEATURE_TOGGLE_DOCKETS_GLOBAL_PDF_DOWNLOAD && (
                  <MenuItem onClick={getDocketsDateRangePdf}>
                    <PictureAsPdfIcon className={classes.iconLeft} />
                    Download PDF
                  </MenuItem>
                )}
              </Menu>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
      {dockets.length === 0 && !isLoading ? (
        <Grid className={cn(classes.noDockets, classes.textAlignCenter)} container justify="center" alignItems="center">
          <Grid item xs={12}>
            <Typography variant="body2">Sorry, no matching dockets found</Typography>
          </Grid>
        </Grid>
      ) : (
        <DocketsTable
          columns={columns}
          requestSortBy={requestSortBy}
          allChecked={allChecked}
          updateCheckAll={updateCheckAll}
          dockets={dockets}
          updateChecked={updateChecked}
          isChecked={isChecked}
          sortBy={sortBy}
          openDetails={openDetails}
          onMenuClick={onMenuClick}
        />
      )}
      {isLoading && (
        <Grid container>
          <Grid item xs={12}>
            <Spinner className={classes.spinner} />
          </Grid>
        </Grid>
      )}
    </div>
  );
};

DocketsList.propTypes = DocketsListPropTypes;

export default compose(
  withWidth(),
  withRouter,
  withServices,
  connect(
    (state) => ({
      listSettings: state.dockets ? state.dockets.listSettings : null,
      userInfo: userProfileSelector(state),
      currentAccountGlobal: getFiltersSelectedAccount(state),
    }),
    (dispatch) => ({
      actions: bindActionCreators(
        {
          ...uiActionCreators,
          ...filtersActionCreators,
          ...docketsActionCreators,
        },
        dispatch,
      ),
    }),
  ),
  withStyles(themeCreateInjectableStyles(docketsListStyles), { withTheme: true }),
)(DocketsList);
